import { React, PropTypes } from 'imports';
import { FormattedResource } from '..';
import { toArray } from 'utils';
import './TabPanel.less';

export const idPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]);

class Tab extends React.PureComponent {
    static get idPropType() {
        return idPropType;
    }

    static get displayName() {
        return 'TabPanel.Tab';
    }

    static get propTypes() {
        return {
            id: idPropType,
            title: PropTypes.oneOfType([FormattedResource.resourcePropType, PropTypes.node]).isRequired,
            disabled: PropTypes.bool,
            className: PropTypes.string,
            children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
        };
    }

    static get defaultProps() {
        return {
            id: null,
            disabled: false,
            className: ''
        };
    }

    render() {
        throw new Error('TabPanel.Tab can be used only inside TabPanel.');
    }
}

export default class TabPanel extends React.Component {
    static get Tab() {
        return Tab;
    }

    static get propTypes() {
        return {
            active: idPropType,
            onChange: PropTypes.func,
            disabled: PropTypes.bool,
            className: PropTypes.string,
            title: PropTypes.oneOfType([FormattedResource.resourcePropType, PropTypes.node])
        };
    }

    static get defaultProps() {
        return {
            active: null,
            disabled: false,
            className: ''
        };
    }

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        var nextProps = this.props;
        this.props = TabPanel.defaultProps;
        this.componentWillReceiveProps(nextProps);
        this.props = nextProps;
    }

    componentWillReceiveProps(nextProps) {
        const children = toArray(nextProps.children || []).filter(v => v);

        if (!children.length) {
            throw new Error('TabPanel requires child elements.');
        }

        const invalidChild = children.find(child => child.type !== Tab);
        if (invalidChild) {
            throw new Error(`${invalidChild} is not an instance of Tab.`);
        }

        const active = nextProps.active !== null ? nextProps.active : this.state && this.state.active;

        this.setState({ active: children.some(child => child.props.id === active) ? active : children[0].props.id });
    }

    _onTabChange = (id, event) => {
        this.setState({ active: id });

        if (this.props.onChange) {
            this.props.onChange(this, id, event);
        }
    }

    render() {
        const children = toArray(this.props.children || []).filter(v => v),
            activeTabProps = children.find((child, index) => child.props.id === this.state.active).props;

        return (
            <div ref="root" className={`tab-panel ${this.props.disabled ? 'disabled' : ''} ${this.props.className}`}>
                <div className="tabs">
                    {
                        this.props.title ?
                            <div className="tabs-title">{React.isValidElement(this.props.title) ? this.props.title : <FormattedResource className="title" resource={this.props.title} />}</div> :
                            null
                    }
                    {children.map(child => (
                        <div key={child.props.id}
                            className={
                                'tab ' +
                                (this.props.disabled || child.props.disabled ? 'disabled ' : '') +
                                (child.props.id === this.state.active ? 'active ' : '') +
                                child.props.className
                            }
                            onClick={
                                this.props.disabled || child.props.disabled ||
                                    child.props.id === this.state.active ? null :
                                    this._onTabChange.bind(this, child.props.id)
                            }>
                            {React.isValidElement(child.props.title) ? child.props.title : <FormattedResource className="title" resource={child.props.title} />}
                        </div>
                    ))}
                </div>
                <div className={activeTabProps.className ? `panel ${activeTabProps.className}-panel` : "panel"}>
                    {typeof activeTabProps.children === 'function' ? activeTabProps.children() : activeTabProps.children}
                </div>
            </div >
        );
    }
}